import React, { useState, useEffect, useContext } from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { loadScript } from '../util';
import { Android, IOS } from '../sub-components';
import styles from './text-an-expert.module.scss';

let cx = classNames.bind(styles);

const iOSScript = 'https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js';
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isiPhone = () => /iPhone/i.test(navigator.userAgent);

const isIOSSupported = () => {
  if (/iPhone/.test(navigator.platform)) {
    const appVersion = (navigator.appVersion);
    const osFullVersion = appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    const version = `
      ${parseInt(osFullVersion[1], 10)}.
      ${parseInt(osFullVersion[2], 10)}.
      ${parseInt(osFullVersion[3] || 0, 10)}`;
    return parseFloat(version) >= 11.3;
  }
  return false;
};

const refreshBusinessChat = () => {
  if (window.appleBusinessChat && window.appleBusinessChat.isSupported()) {
    window.appleBusinessChat.refresh();
  }
};

const TextAnExpert = ({ disableFeature }) => {

  const { channel, isServer } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('text-an-expert.ready'); }, []);
  useEffect(() => {
    if (isIOSSupported) {
      loadScript(iOSScript).then(refreshBusinessChat);
    }
  });

  if (disableFeature || !isMobile || isServer || (!isAndroid() && !isiPhone())) return null;
  return (
    <div className={cx('text-an-expert')}>
      <div className="col__12-12 col__7-12--mini">
        <div className={cx('business-chat')}>
          {isAndroid() && <Android />}
          {isiPhone() && <IOS />}
        </div>
      </div>
    </div>
  );
};

TextAnExpert.displayName = 'TextAnExpert';

TextAnExpert.propTypes = {
  disableFeature: bool
};
TextAnExpert.defaultProps = {
  disableFeature: false
};

export { TextAnExpert };
